import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    employeeRecomandation: boolean ,
    employeeRecomandationName:string,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    employeeRecomandation: boolean = false;
    employeeRecomandationName: string = "";
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "employeeRecomandation", value: this.employeeRecomandation ? "-1":"0" },
            { name: "employeeRecomandationName", value: this.employeeRecomandationName},
        );

        return application;
    }
}
